import AddTemplate from "../components/AddTemplate";

export default AddTemplate